<script>
import {
    Stage as VStage,
    Layer as VLayer,
    Group as VGroup,
    Rect as VRect,
    Text as VText,
} from 'vue-konva';

export default {
    components: {
        VStage,
        VLayer,
        VGroup,
        VRect,
        VText,
    },
    props: {
        is_readonly: {
            type: Boolean,
            default: true
        },
        reservation: {
            type: Object,
            required: true
        },
        stuff_id: {
            required: false,
        },
        stuff: {
            type: Array,
            required: true
        },
        available: {
            type: Array,
            required: false
        }
    },
    data() {
        var width = 1200;
        var height = 600;

        return {
            default_color: 'ffffff',
            default_text_color: '000000',

            selected_color: '45cb85',
            selected_text_color: 'ffffff',

            reserved_color: 'f87171',
            reserved_text_color: 'ffffff',

            stageSize: {
                width: width,
                height: height
            },
            background: {
                x: 0,
                y: 0,
                width: width,
                height: height,
                fill: '#f9fafb',
                stroke: '#111827',
                strokeWidth: 3
            }
        }
    },
    computed: {
        mappedAvailable() {
            var vm = this;

            var available = vm.$_.map(vm.available, function (y) {
                if (y.reservation_id == vm.reservation.id)
                    y.is_available = 1;

                return y;
            });

            return available;
        },
        mappedStuff() {
            var vm = this;

            return [...vm.stuff]
                .sort((a, b) => a.layer - b.layer)
                .map(function (x) {
                    var exists = vm.$_.find(vm.mappedAvailable, function (y) {
                        return y.stuff_id == x.id && y.is_available == 0
                    });

                    var is_reserved = false;
                    if (exists)
                        is_reserved = true;

                    var is_selected = false;
                    if (vm.stuff_id == x.id)
                        is_selected = true;

                    var color = vm.default_color;
                    var text_color = vm.default_text_color;

                    if (x.is_static == 1) {
                        color = x.color;
                        text_color = x.text_color;
                    }

                    if (!vm.is_readonly && is_reserved) {
                        color = vm.reserved_color;
                        text_color = vm.reserved_text_color;
                    }

                    if ((vm.is_readonly && is_selected) || (is_selected && !vm.is_readonly)) {
                        color = vm.selected_color;
                        text_color = vm.selected_text_color;
                    }

                    return {
                        model: x,
                        shape: x.shape,
                        group: {
                            x: x.x,
                            y: x.y,
                            offsetX: x.width / 2,
                            offsetY: x.height / 2,
                            rotation: x.rotation,
                            draggable: false,
                        },
                        stuff: {
                            x: 0,
                            y: 0,
                            width: x.width,
                            height: x.height,
                            fill: '#' + color,
                            stroke: '#' + text_color,
                            strokeWidth: 1,
                            cornerRadius: 2,
                        },
                        text: {
                            text: x.number,
                            x: 0,
                            y: 0,
                            width: x.width,
                            height: x.height,
                            align: 'center',
                            verticalAlign: 'middle',
                            fontSize: 10,
                            fill: '#' + text_color,
                            fontStyle: 'normal',
                            listening: false
                        },
                    };
                });
        },
    },
    methods: {
        onSelect(tr) {
            var vm = this;

            if (!vm.is_readonly && vm.available.length == 0)
                return

            var is_reserved = false;
            if (vm.mappedAvailable) {
                var exists = vm.$_.find(vm.mappedAvailable, function (y) {
                    return y.stuff_id == tr.id && y.is_available == 0
                });

                if (exists)
                    is_reserved = true;
            }

            if (!vm.is_readonly && !is_reserved && tr.is_static == 0) {
                vm.$emit('onSelect', tr)
            }
        },
        setCursor(type) {
            const stage = this.$refs.stage.getStage()
            stage.container().style.cursor = type
        },
        onMouseEnter(tr) {
            var vm = this;

            if (!vm.is_readonly && vm.available.length == 0)
                return

            var is_reserved = false;
            if (vm.mappedAvailable) {
                var exists = vm.$_.find(vm.mappedAvailable, function (y) {
                    return y.stuff_id == tr.id && y.is_available == 0
                });

                if (exists)
                    is_reserved = true;
            }

            if (!vm.is_readonly && !is_reserved && tr.is_static == 0) {
                vm.setCursor('pointer')
            }
        },
        onMouseLeave() {
            var vm = this;

            vm.setCursor('default')
        },
    }
}
</script>

<template>
    <v-stage :config="stageSize" ref="stage">
        <v-layer>
            <v-rect :config="background" />
            <v-group v-for="(tr, index) in mappedStuff" :key="'stuff-' + index" :config="tr.group"
                @click="onSelect(tr.model)" @mouseenter="onMouseEnter(tr.model)" @mouseleave="onMouseLeave">
                <v-rect :config="tr.stuff" />
                <v-text :config="tr.text" />
            </v-group>
        </v-layer>
    </v-stage>
</template>